const userAgent = navigator.userAgent.toLowerCase()

export const isLinux = userAgent.includes('linux')
export const isWindows = userAgent.includes('windows')
export const isMacOS = userAgent.includes('mac')

// 普通edge: Edge, chromium版Edg
export const isEdgeBrowser = /(?:^|\s)edge?\/(?:\d+\.?)+(?:$|\s)/.test(userAgent)

const isIphone = !!userAgent.match(/iphone|ipod|iOS/g)
const isIpad = !!userAgent.match(/ipad/g) || (!isIphone && 'ontouchend' in document)
const isAndroid = !!userAgent.match(/android/g)
const isWechat = !!userAgent.match(/micromessenger/g)
const isAlipay = !!userAgent.match(/alipayclient/g)
export const isMobile = isIpad || isIphone || isAndroid || isWechat || isAlipay

export const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent)
